// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"57":"8395534f","61":"1b42e73a"}[chunkId] + ".css";
};